// @flow
import React, { useEffect, useMemo, useState } from 'react';
import Typography from "@mui/material/Typography";
import FilterListIcon from "@mui/icons-material/FilterList";
import Filters from "./filters";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../locales/components/namespaces";
import useExhibitionAction from "../../../hooks/exhibitions/useExhibitionAction";
import useExhibitionsData from "../../../hooks/exhibitions/useExhibitionsData";
import { enqueueSnackbar } from "notistack";
import List from "@mui/material/List";
import ExhibitionGroupedHeadersPreview from "../../../components/app/exhibitionPreview/exhibitionGroupedHeadersPreview";
import Grid from '@mui/material/Grid2';
import ContentLoader from "../../../components/general/contentLoader/contentLoader";
import ExhibitionPreview from "../../../components/app/exhibitionPreview/exhibitionPreview";
import { filterExhibitions, filterHeaders } from "../../../helpers/filterExhibitions";
import FilterHeaders from "./filtersHeaders";

type Props = {};

const OrganizerView = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const [filterFunctionParameters, setFilterFunctionParameters] = useState({})
	const [filterHeadersParameters, setFilterHeadersParameters] = useState({})
	const { getExhibitionsGroupedDetails, getExhibitionsGroupedHeaders, setSelectedExhibitionGroupedHeader, setExhibitionMessage } = useExhibitionAction()
	const { exhibitionsGroupedHeaders, message, loadingGroupedHeaders, indexTable, selectedGroupedHeader } = useExhibitionsData()
	const items = useMemo(() => (filterExhibitions(indexTable.items, filterFunctionParameters)), [filterFunctionParameters, indexTable.items])
	const headers = useMemo(() => (filterHeaders(exhibitionsGroupedHeaders, filterHeadersParameters)), [exhibitionsGroupedHeaders, filterHeadersParameters])
	
	useEffect(() => {
		getExhibitionsGroupedHeaders()
	}, [getExhibitionsGroupedHeaders])
	
	useEffect(() => {
		if (selectedGroupedHeader) {
			getExhibitionsGroupedDetails(selectedGroupedHeader)
		}
	}, [getExhibitionsGroupedDetails, selectedGroupedHeader])
	
	useEffect(() => {
		if (message) {
			enqueueSnackbar(t(message?.text), {
					variant: message?.variant
				}
			)
			setExhibitionMessage(null)
		}
	}, [message, setExhibitionMessage, t])
	return (
		<Box sx={{ p: 0 }}>
			<Grid container>
				<Grid size={{ xs: 12, sm: 12, md: 5, lg: 4 }} sx={{ background: '#FFFFFF', p: 1 }}>
					<Typography variant={"subtitle2"} sx={{ mb: -1.25, pt: 2, ml: 1, color: '#31373A' }}>
						<FilterListIcon fontSize={"inherit"}/> <span>{t('FILTER BY')}</span>
					</Typography>
					<FilterHeaders
						onFilterChange={setFilterHeadersParameters}
					/>
					<Divider sx={{ mb: 2 }}/>
					{!loadingGroupedHeaders ? (
						<List
							sx={{
								height: {
									xs: '300px',
									sm: '300px',
									md: 'inherit'
								},
								overflowY: {
									xs: 'auto',
									sm: 'auto',
									md: 'inherit'
								},
							}}
						>
							{headers.map(i => (
								<ExhibitionGroupedHeadersPreview
									selected={selectedGroupedHeader}
									setSelected={setSelectedExhibitionGroupedHeader}
									key={i.DescriptionEN}
									header={i.DescriptionEN}
									description={i.description}
									getExhibitionsGroupedDetails={getExhibitionsGroupedDetails}
								/>
							))}
						</List>
					) : (
						<ContentLoader
							loading={loadingGroupedHeaders}
						/>
					)}
				</Grid>
				<Grid size={{ xs: 12, sm: 12, md: 7, lg: 8 }} sx={{ background: 'rgba(243,229,245,0.4)', p: 1 }}>
					<Typography variant={"subtitle2"} sx={{ mb: -1.25, pt: 2, ml: 1,  color: '#31373A' }}>
						<FilterListIcon fontSize={"inherit"}/> <span>{t('FILTER BY')}</span>
					</Typography>
					<Filters
						onFilterChange={setFilterFunctionParameters}
					/>
					<Divider sx={{ mb: 2 }}/>
					
					{!indexTable.loading && !loadingGroupedHeaders ? (
						<List>
							{items.map(i => (
								<ExhibitionPreview
									key={i.id}
									exhibition={i}
								/>
							))}
						</List>
					) : (
						<ContentLoader
							loading={loadingGroupedHeaders || indexTable.loading}
						/>
					)}
				</Grid>
			</Grid>
		</Box>
	)
};

export default OrganizerView